import { ReactNode } from "react";
import './styles.css';
import { Popover } from "antd";
import FAIcon from "../FAIcon/FAIcon";

interface Props {
    children: ReactNode;
    content?: ReactNode;
}

const InformationBadge = (props: Props) => {
    return (
        <div className="information-badge">
            {props.children}
            <Popover content={props.content}>
                <FAIcon prefix='fad' name='circle-info' color="var(--error)" className="information-badge-icon"/>
            </Popover>
        </div>
    );
};

export default InformationBadge;